import React from 'react'
import RaisedButton from '../buttons/RaisedButton'
import { formatName, Auth } from '../../../../helpers'

const addMoreAnswerStyles = (answer) => {
  if (answer.participant.avatar) {
    return {
      background: `url('${answer.participant.avatar}')`,
      backgroundSize: '30px 30px'
    }
  }
  return {}
}

const Answer = (props) => (
  <div className='answer-wrap'>
    <div className='user-left-wrap' key='0'>
      <div className='user-image' style={addMoreAnswerStyles(props.answer)} />
    </div>
    <div className='body-right-wrap' key='1'>
      <div className='name-wrap'>
        <span>{formatName(props.answer.participant.name)} {props.answer.participant.handle}</span>
      </div>
      <div className='text-wrap'>
        <span> {props.answer.text.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)} </span>
      </div>
      <div className='buttons-wrap'>
        {Auth.isAdmin() && (
          <RaisedButton text='edit' onClick={() => {
            if (props.onAnswerEdit) {
              props.onAnswerEdit(props.answer)
            }
          }} />
        )}
      </div>
    </div>
  </div>
)

export default Answer



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/comments/Answer.js